// @ts-nocheck
import * as Types from '../../../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { MaterialCatalog_AssetFragmentDoc } from '../../../../../../libraries/material-catalog/MaterialCatalog.generated';
export type ProductCard_MaterialVariantFragment = { __typename?: 'MaterialVariant', id: string, displayName: string, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, version: string, url: string, fileName?: string | null | undefined, contentType: string, downloadUrl: string, attachmentUrl: string, previewUrl?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'] } | null | undefined } | null | undefined, listing: { __typename?: 'MaterialListing', id: string, name?: string | null | undefined, brand?: { __typename?: 'MaterialBrand', id: string, name: string } | null | undefined } };

export type ProductCard_LocationFragment = { __typename?: 'Location', id: string, displayLocationPath: string };

export const ProductCard_MaterialVariantFragmentDoc = gql`
    fragment ProductCard_MaterialVariant on MaterialVariant {
  id
  displayName
  featuredImage {
    id
    asset {
      ...MaterialCatalog_Asset
    }
  }
  listing {
    id
    name
    brand {
      id
      name
    }
  }
}
    ${MaterialCatalog_AssetFragmentDoc}`;
export const ProductCard_LocationFragmentDoc = gql`
    fragment ProductCard_Location on Location {
  id
  displayLocationPath
}
    `;